import { AnswersService } from "@/common/api.service"
import { FETCH_ANSWERS, FETCH_INDIVIDUAL_ANSWER, ADD_ANSWER, UPDATE_ANSWER, DELETE_ANSWER, RESET_STATE} from "./actions.type"
import { SET_ANSWER, SET_INDIVIDUAL_ANSWER, SET_ERROR_ANSWER, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        answers: [],
        individualanswer: [],
        answererrors: null,
    }
}

let state = initialState()

const getters = {
    answers(state) {
        return state.answers
    },
    individualanswer(state) {
        return state.individualanswer
    },
}

const actions = {
    async [FETCH_ANSWERS](context, slug) {
        const { data } = await AnswersService.get(slug)
        context.commit(SET_ANSWER, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_ANSWER](context, slug) {
        const { data } = await AnswersService.get(slug)
        context.commit(SET_INDIVIDUAL_ANSWER, data.data)
        return data;
    },  
    async [ADD_ANSWER](context, payload) {
        return await AnswersService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_ANSWER, error.response.data.errors)
        });
    },     
    async [UPDATE_ANSWER](context, payload) {
        // return await AnswersService.update(payload, payload.get('question_id'))
        return await AnswersService.update(payload, payload.question_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_ANSWER, error.response.data.errors)
        });
    },  
    async [DELETE_ANSWER] (context, id) {
        return await AnswersService.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_ANSWER, error.response.data.errors)
        });
    },  
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_ANSWER](state, error) {
        state.answererrors = error
    },      
    [SET_ANSWER](state, answerdata) {
        state.answers = answerdata
    },
    [SET_INDIVIDUAL_ANSWER](state, individualanswer) {
        state.individualanswer = individualanswer
    },  
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};